import React from 'react';
import styled from 'styled-components';
import { Alert } from '@brokerbay/elements-web';
import { Timezone } from '@bb/domain/dist/types';
import { formatTimeStr, formatDateStrWithYearAndFullDayNoOrd } from 'utils';
import { BORDER_RADIUS } from '../../constants';

type PreviousTimeBannerProps = {
  originalTime: string;
  originalTimeEnd: string;
  timezone: Timezone;
};

const PreviousTimeBanner: React.FC<PreviousTimeBannerProps> = ({
  originalTime,
  originalTimeEnd,
  timezone,
}) => {
  const originalDateWithYearStr = formatDateStrWithYearAndFullDayNoOrd(
    originalTime,
    timezone,
  );
  const originalTimeStr = formatTimeStr(originalTime, timezone);
  const originalTimeEndStr = formatTimeStr(originalTimeEnd, timezone);
  return (
    <StyledAlert
      type="info"
      data-cy="showingDetails-previousTime-banner"
      showIcon
      message={`Previously: ${originalDateWithYearStr} • ${originalTimeStr} - 
        ${originalTimeEndStr}`}
    />
  );
};
export default PreviousTimeBanner;

const StyledAlert = styled(Alert)`
  && {
    padding: 8px;
    margin-bottom: 24px;
    border: 1px solid #91c3ff;
    border-radius: ${BORDER_RADIUS}px;
    align-items: flex-start;
    .anticon {
      line-height: 22px;
      padding-top: 2px;
    }
  }
`;
